import { createRouter, createWebHistory } from 'vue-router'

import login from '@/views/login.vue'
import profile from '../views/profile.vue'
import details from '../views/details.vue'
import invoices from '../views/invoices.vue'
import appointments from '../views/appointments.vue'

const routes = [
    
    {
        path: '/login',
        name: 'Login',
        component: login,
        beforeEnter: (to, from, next) => {
            const token = localStorage.getItem('token')
            if(token) next('/')
            else next()
        }
    },
    {
        alias: '/',
        path: '/appointments',
        name: 'Appointments',
        component: appointments,
        beforeEnter: (to, from, next) => {
            const token = localStorage.getItem('token')
            if(!token) next('/login')
            else next()
        }
    },
    {
        path: '/invoices',
        name: 'Invoices',
        component: invoices
    },
    {
        path: '/details',
        name: 'Details',
        component: details
    },
    {
        path: '/profile',
        name: 'Profile',
        component: profile
    }

]

const router = createRouter({

    routes,
    history: createWebHistory(process.env.BASE_URL)

})

export default router